export function capitalize(str: string): string {
  return str.charAt(0).toUpperCase() + str.slice(1);
}

const EXTERNAL_HREF = /^(https?:\/\/|mailto:)/;

export const externalLinkProps = (href: string) =>
  EXTERNAL_HREF.test(href)
    ? ({ rel: "noopener noreferrer", target: "_blank" } as const)
    : {};
